export const CHART_COLORS = {
  navy: '#1E2D5C',
  navyMuted: 'rgba(30,45,92,0.35)',
  gold: '#C9A867',
  goldMuted: 'rgba(201,168,103,0.25)',
  danger: '#C2410C',
  success: '#166534',
  hairline: '#E8E4DC',
  ink: '#0A1228',
  inkMuted: '#4A5066',
} as const;

export const CHART_TICK = {
  style: { fill: CHART_COLORS.inkMuted, fontSize: 10, fontFamily: 'JetBrains Mono, monospace', textTransform: 'uppercase' },
};
